import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  /* =======================
     PALETTE
  ======================= */
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#0f172a",
    },
    text: {
      primary: "#111827",
      secondary: "#6b7280",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },

  /* =======================
     TYPOGRAPHY
  ======================= */
  typography: {
    fontFamily: "'Inter', sans-serif, arial",
    fontSize: 13, // ⬇️ base font size (was 14)

    h1: { fontSize: "2rem", fontWeight: 700 },
    h2: { fontSize: "1.65rem", fontWeight: 700 },
    h3: { fontSize: "1.35rem", fontWeight: 600 },
    h4: { fontSize: "1.15rem", fontWeight: 600 },
    h5: { fontSize: "1rem", fontWeight: 600 },
    h6: { fontSize: "0.9rem", fontWeight: 600 },

    body1: {
      fontSize: "0.9rem",
      fontWeight: 400,
      lineHeight: 1.55,
    },

    body2: {
      fontSize: "0.8rem",
      fontWeight: 400,
    },

    button: {
      fontSize: "0.8rem",
      fontWeight: 600,
      textTransform: "none",
    },

    caption: {
      fontSize: "0.7rem",
      color: "#9ca3af",
    },
  },

  /* =======================
     SHAPE
  ======================= */
  shape: {
    borderRadius: 12,
  },

  /* =======================
     COMPONENT OVERRIDES
  ======================= */
  components: {
    /* ===== GLOBAL BASELINE ===== */
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: "18px",
          WebkitTextSizeAdjust: "100%",
          textSizeAdjust: "100%",
        },
        body: {
         
          margin: 0,
          padding: 0,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },

        ":root": {
          /* ===== COLORS ===== */
          "--color-primary": "#CD1479",
          "--color-primary-hover": "#B01268",
          "--color-primary-disabled": "#F0A6C9",
          "--color-secondary": "#8FD3E8",

          "--color-black": "#000000",
          "--black-muted": "#2B2B2B",
          "--text-muted": "#00000080",
          "--text-gray":"#757575",

          /* ===== FONT WEIGHTS ===== */
          "--fw-light": "300",
          "--fw-regular": "400",
          "--fw-semibold": "500",
          "--fw-bold": "600",

          /* ===== RESPONSIVE FONT SIZES ===== */
  " --fs-xxs": "clamp(0.65rem, 0.3vw, 0.75rem)",
 " --fs-xs":" clamp(0.75rem, 0.5vw, 0.85rem)",
 " --fs-sm": "clamp(0.85rem, 0.7vw, 0.95rem)",
 " --fs-md": "clamp(1rem, 0.9vw, 1.1rem)",
 " --fs-lg":" clamp(1.15rem, 1.2vw, 1.35rem)",
 " --fs-xl": "clamp(1.3rem, 1.8vw, 1.8rem)",

          /* ===== SPACING ===== */
          "--space-xs": "4px",
          "--space-sm": "8px",
          "--space-md": "12px",
          "--space-lg": "16px",

          /* ===== RADIUS ===== */
          "--radius-sm": "6px",
          "--radius-md": "10px",
          "--radius-lg": "12px",
          "--radius-xl": "16px",
        },
      },
    },

    /* ===== TYPOGRAPHY RESPONSIVE ===== */
    MuiTypography: {
      styleOverrides: {
        h1: {
          "@media (max-width:600px)": { fontSize: "1.75rem" },
        },
        h2: {
          "@media (max-width:600px)": { fontSize: "1.5rem" },
        },
        h3: {
          "@media (max-width:600px)": { fontSize: "1.25rem" },
        },
        body1: {
          "@media (max-width:600px)": { fontSize: "0.9rem" },
        },
      },
    },

    /* ===== BUTTON ===== */
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.9rem",
          padding: "10px 16px",
        },
      },
    },

    /* ===== CARD ===== */
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
        },
      },
    },
  },
});

export default theme;
